import React from "react";

interface CodeIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const CodeIcon: React.FC<CodeIconProps> = ({ size = 33, color = '#003366', className, onClick }) => (
  <svg width={size} height={size} viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.82 13.5244L8.11499 16.2294L10.82 18.9344" stroke={color} strokeWidth="2.02875" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M21.6401 13.5244L24.3451 16.2294L21.6401 18.9344" stroke={color} strokeWidth="2.02875" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16.2298 29.7551C23.6995 29.7551 29.7548 23.6997 29.7548 16.2301C29.7548 8.76043 23.6995 2.70508 16.2298 2.70508C8.76018 2.70508 2.70483 8.76043 2.70483 16.2301C2.70483 23.6997 8.76018 29.7551 16.2298 29.7551Z" stroke={color} strokeWidth="2.02875" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17.5824 13.0784L14.8774 19.3811" stroke={color} strokeWidth="2.02875" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default CodeIcon;
